module.exports = __webpack_public_path__ + "img/3_3.1992ddb9.png";